import React, { useEffect, useState, useMemo } from 'react';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store.js';

import Layout from '../Components/Layout/Layout.js';
import PageTitle from '../Components/PageTitle.js';
import PromotionDropdown from '../Components/PromotionDropdown.js';
import DrawingsTable from '../Components/DrawingsTable.js';
import { getCMSObject } from 'sg-ui-components';

const useQuery = () => {
    const { search } = useLocation();
    return useMemo(() => new URLSearchParams(search), [search]);
};

const DrawingsPage = ({ user, config, cmsSourceFirebase, drawings, actions }) => {
    const promo = useQuery().get('promotion') ?? 0;
    const [promotionId, setPromotionId] = useState(promo);

    useEffect(() => {
        setPromotionId(drawings?.promotionId);
    }, [drawings?.drawings]);

    const page = {
        title: getCMSObject('data.microsite.general.drawingsAndWinners.pageInfo.pageTitle'),
        className: 'drawings',
    };

    return (
        <Layout {...{ page, user, config, cmsSourceFirebase, actions }}>
            <div className='page-info'>
                <PageTitle title={page?.title} />
            </div>
            <div className='form-container'>
                <PromotionDropdown
                    className={`m-2`}
                    label='Promotion Name'
                    id='promotion'
                    name='promotion'
                    placeholder=''
                    selected={promotionId}
                    changeHandler={(e) => setPromotionId(e.target.value)}
                />
            </div>
            <div className='drawing-container'>
                <DrawingsTable promotionId={promotionId} />
            </div>
        </Layout>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(DrawingsPage);
